import { render, staticRenderFns } from "./bindAtTheInformation.vue?vue&type=template&id=72970383&scoped=true&"
import script from "./bindAtTheInformation.vue?vue&type=script&lang=js&"
export * from "./bindAtTheInformation.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tablecss.less?vue&type=style&index=0&id=72970383&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72970383",
  null
  
)

export default component.exports